export default __webpack_public_path__ + "static/media/loader_white_bg.1e7e0650.mp4";